export default __webpack_public_path__ + "static/media/F.ff3df3cc.png";